import PropTypes from 'prop-types';
import React from 'react';

var ChartYaxis = function ChartYaxis(_ref) {
  var ticks = _ref.ticks,
      scale = _ref.scale,
      x = _ref.x,
      y = _ref.y,
      width = _ref.width,
      height = _ref.height,
      tickWidth = _ref.tickWidth,
      tickFormat = _ref.tickFormat;
  return React.createElement("g", {
    className: "ChartYaxis",
    transform: "translate(".concat(x, ", ").concat(y, ")")
  }, React.createElement("line", {
    className: "ChartYaxis-line",
    y1: height,
    y2: height,
    x1: "0",
    x2: width
  }), ticks.map(function (tick) {
    var scaledTick = scale(tick);
    return React.createElement("g", {
      key: tick
    }, React.createElement("line", {
      className: "ChartYaxis-tick",
      y1: scaledTick,
      y2: scaledTick,
      x1: "0",
      x2: tickWidth
    }), React.createElement("text", {
      className: "ChartYaxis-label",
      x: "0",
      y: scaledTick
    }, tickFormat(tick)));
  }));
};

ChartYaxis.displayName = 'ChartYaxis';
ChartYaxis.propTypes = {
  ticks: PropTypes.array,
  scale: PropTypes.func.isRequired,
  x: PropTypes.number,
  y: PropTypes.number,
  width: PropTypes.number,
  height: PropTypes.number,
  tickWidth: PropTypes.number,
  tickFormat: PropTypes.func
};
ChartYaxis.defaultProps = {
  tickWidth: 6,
  tickFormat: function tickFormat(tick) {
    return tick;
  }
};
export default ChartYaxis;